<div class="select-frequency-container">
  <!-- Frequency Type Selector -->
  <div class="mb-4">
    <label for="frequency-type" class="block text-sm font-medium mb-2">
      Select Frequency Type
    </label>
    <p-select
      inputId="frequency-type"
      [(ngModel)]="frequencyType"
      [options]="frequencyTypes"
      (onChange)="onFrequencyTypeChange()"
      placeholder="Select frequency type"
      styleClass="w-full"
      appendTo="body"
    />
  </div>

  <!-- Days Frequency -->
  <div *ngIf="frequencyType === 'Days'" class="frequency-days mb-4">
    <label for="days-frequency" class="block text-sm font-medium mb-2">
      Select Frequency
    </label>
    <p-select
      inputId="days-frequency"
      [(ngModel)]="frequency"
      [options]="getDropdownOptions(daysFrequencyRange)"
      (onChange)="onFrequencyChange(frequency!)"
      placeholder="Select frequency"
      styleClass="w-full"
      appendTo="body"
    />
  </div>

  <!-- Custom Days Input -->
  <div *ngIf="frequencyType === 'Days' && showCustom" class="mb-4">
    <label for="custom-days" class="block text-sm font-medium mb-2">
      How many days
    </label>
    <p-inputNumber
      inputId="custom-days"
      [(ngModel)]="customFrequency"
      (onInput)="onCustomFrequencyInput()"
      [min]="1"
      [max]="366"
      placeholder="Enter number of days"
      inputStyleClass="w-full"
    />
  </div>

  <!-- Day of the Week Frequency -->
  <div
    *ngIf="frequencyType === 'DayOfTheWeek'"
    class="frequency-day-of-the-week mb-4"
  >
    <label class="block text-sm font-medium mb-2">Select Day of the Week</label>
    <div class="calendar-table flex justify-center gap-2">
      <div *ngFor="let d of dayOfTheWeekFrequencyRange" class="day-option">
        <input
          type="radio"
          [id]="'frequency-day-of-the-week-' + d.value"
          name="frequency-day-of-the-week"
          [value]="d.value"
          [checked]="d.value === frequency"
          (change)="onFrequencyRadioChange(d.value)"
          class="hidden"
        />
        <label
          [for]="'frequency-day-of-the-week-' + d.value"
          class="day-label cursor-pointer border-2 rounded px-3 py-2 text-center block min-w-[50px]"
          [class.selected]="d.value === frequency"
        >
          {{ d.name }}
        </label>
      </div>
    </div>
  </div>

  <!-- Weeks Frequency -->
  <div *ngIf="frequencyType === 'Weeks'" class="frequency-weeks mb-4">
    <label for="weeks-frequency" class="block text-sm font-medium mb-2">
      Select Frequency
    </label>
    <p-select
      inputId="weeks-frequency"
      [(ngModel)]="frequency"
      [options]="getDropdownOptions(weeksFrequencyRange)"
      (onChange)="onFrequencyChange(frequency!)"
      placeholder="Select frequency"
      styleClass="w-full"
      appendTo="body"
    />
  </div>

  <!-- Custom Weeks Input -->
  <div *ngIf="frequencyType === 'Weeks' && showCustom" class="mb-4">
    <label for="custom-weeks" class="block text-sm font-medium mb-2">
      How many weeks
    </label>
    <p-inputNumber
      inputId="custom-weeks"
      [(ngModel)]="customFrequency"
      (onInput)="onCustomFrequencyInput()"
      [min]="1"
      [max]="48"
      placeholder="Enter number of weeks"
      inputStyleClass="w-full"
    />
  </div>

  <!-- Months Frequency -->
  <div *ngIf="frequencyType === 'Months'" class="frequency-months mb-4">
    <label for="months-frequency" class="block text-sm font-medium mb-2">
      Select Frequency
    </label>
    <p-select
      inputId="months-frequency"
      [(ngModel)]="frequency"
      [options]="getDropdownOptions(monthsFrequencyRange)"
      (onChange)="onFrequencyChange(frequency!)"
      placeholder="Select frequency"
      styleClass="w-full"
      appendTo="body"
    />
  </div>

  <!-- Custom Months Input -->
  <div *ngIf="frequencyType === 'Months' && showCustom" class="mb-4">
    <label for="custom-months" class="block text-sm font-medium mb-2">
      How many months
    </label>
    <p-inputNumber
      inputId="custom-months"
      [(ngModel)]="customFrequency"
      (onInput)="onCustomFrequencyInput()"
      [min]="1"
      [max]="12"
      placeholder="Enter number of months"
      inputStyleClass="w-full"
    />
  </div>

  <!-- Day of the Month Frequency -->
  <div
    *ngIf="frequencyType === 'DayOfTheMonth'"
    class="frequency-day-of-the-month mb-4"
  >
    <label class="block text-sm font-medium mb-2"
      >Select Day of the Month</label
    >
    <div class="calendar-table">
      <div
        *ngFor="let week of dayOfTheMonthFrequencyRange"
        class="flex justify-center gap-2 mb-2"
      >
        <div *ngFor="let d of week" class="day-option">
          <input
            type="radio"
            [id]="'frequency-day-of-the-month-' + d"
            name="frequency-day-of-the-month"
            [value]="d"
            [checked]="d === frequency"
            (change)="onFrequencyRadioChange(d)"
            class="hidden"
          />
          <label
            [for]="'frequency-day-of-the-month-' + d"
            class="day-label cursor-pointer border-2 rounded px-2 py-2 text-center block min-w-[40px]"
            [class.selected]="d === frequency"
          >
            {{ d }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
